import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-6" }

import SelectOrganization from "@/components/RoleAssignment/SelectOrganization.vue"
import organizationType from "@/types/requests/organizationType"
import RoleName from "@/components/RoleAssignment/RoleName.vue"
import getRole from "@/types/responses/getRole"
import { ref, Ref, computed } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'RoleSelect',
  props: {
    modelValue: {},
    organizations: {},
    roles: {},
    windowInnerWidth: {},
    errorMessages: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit

const props = __props

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value)
  }
})

const selectableRoles = computed(() => {
  if (!props.modelValue.organization) return []
  return props.roles.filter((role: getRole) => {
    return role.organization_id == props.modelValue.organization?.id &&
      role.organization_type == props.modelValue.organization?.type
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SelectOrganization, {
      modelValue: modelValue.value.organization,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue.value.organization) = $event)),
      organizations: props.organizations,
      windowInnerWidth: __props.windowInnerWidth,
      errorMessages: props.errorMessages.organization
    }, null, 8, ["modelValue", "organizations", "windowInnerWidth", "errorMessages"]),
    _createVNode(RoleName, {
      modelValue: modelValue.value.role,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue.value.role) = $event)),
      roles: selectableRoles.value,
      windowInnerWidth: __props.windowInnerWidth,
      errorMessages: props.errorMessages.roleType
    }, null, 8, ["modelValue", "roles", "windowInnerWidth", "errorMessages"])
  ]))
}
}

})